// extracted by mini-css-extract-plugin
export default {"tabs":"TabsRating_tabs__W8rKQ","tab":"TabsRating_tab__1WsG5","active":"TabsRating_active__ftIpg"};